import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from 'ui';

// A fixed id is safe: a closed MUI Dialog renders no children, so only one notice is ever in the DOM.
const DIALOG_ID = 'no-ai-programs-dialog';
const EMPTY_TITLE_ID = `${DIALOG_ID}-empty-title`;
const EMPTY_DESCRIPTION_ID = `${DIALOG_ID}-empty-description`;

type NoAiProgramsDialogProps = {
  isOpen?: boolean;
  onClose: () => void;
};

/** Takes the lesson picker's place when the teacher has no AI programs: an empty picker reads as an error. */
function NoAiProgramsDialog({ isOpen = false, onClose }: Readonly<NoAiProgramsDialogProps>): JSX.Element {
  const { t } = useTranslation(['chatbot']);

  return (
    <Dialog
      ariaDescribedBy={`${EMPTY_TITLE_ID} ${EMPTY_DESCRIPTION_ID}`}
      buttonTextSuccess={t('chatbot:lesson_selection_no_programs_cta')}
      className="no-ai-programs-dialog"
      id={DIALOG_ID}
      isOpen={isOpen}
      onClose={onClose}
      onSuccess={onClose}
      size="s"
      title={t('chatbot:Choose content from program')}
    >
      <div className="no-ai-programs-dialog__empty">
        {/* h3: the Dialog renders its title as h2. */}
        <h3 className="no-ai-programs-dialog__empty-title" id={EMPTY_TITLE_ID}>
          {t('chatbot:lesson_selection_no_programs_title')}
        </h3>
        <p className="no-ai-programs-dialog__empty-description" id={EMPTY_DESCRIPTION_ID}>
          {t('chatbot:lesson_selection_no_programs_description')}
        </p>
      </div>
    </Dialog>
  );
}

export default NoAiProgramsDialog;
